import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-docs-bot',
  template: ` <div id="docsbotai-root"></div> `,
  styles: [],
})
export class DocsBotComponent implements OnInit, AfterViewInit {
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const policyName = localStorage.getItem('policyName');
    const userType = localStorage.getItem('ut')?.toLowerCase();

    const showDocsBot =
      policyName === 'Operator' ||
      policyName === 'Senior Operator Role' ||
      policyName === 'Admin' ||
      userType === 'useradmin' ||
      userType === 'admin';

    if (showDocsBot) {
      (window as any).DocsBotAI = (window as any).DocsBotAI || {};
      (window as any).DocsBotAI.init = function (e: any) {
        return new Promise<void>((t, r) => {
          var n = document.createElement('script');
          n.type = 'text/javascript';
          n.async = !0;
          n.src = 'https://widget.docsbot.ai/chat.js';
          let o = document.getElementsByTagName('script')[0];
          o.parentNode.insertBefore(n, o);
          n.addEventListener('load', () => {
            let n;
            Promise.all([
              new Promise<void>((resolve, reject) => {
                (window as any).DocsBotAI.mount(Object.assign({}, e))
                  .then(resolve)
                  .catch(reject);
              }),
              (n = function e(t: any): Promise<any> {
                return new Promise<any>((resolve) => {
                  if (document.querySelector(t)) {
                    return resolve(document.querySelector(t));
                  }
                  let r = new MutationObserver((n) => {
                    if (document.querySelector(t)) {
                      resolve(document.querySelector(t));
                      r.disconnect();
                    }
                  });
                  r.observe(document.body, { childList: !0, subtree: !0 });
                });
              })('#docsbotai-root'),
            ])
              .then(() => t(undefined))
              .catch(r);
          });
          n.addEventListener('error', (e) => {
            r(e.message);
          });
        });
      };
      (window as any).DocsBotAI.init({
        id: 'ZdcUBjHkHF017MGzd9mB/3Rz1xIulDBf9LbCNx2MX',
      });
    }
  }
}
